import React from 'react'
import { SnackbarProvider } from 'notistack'

import { SvgInfoIcon } from '@assets/SvgInfoIcon'
import { CssBaseline, makeStyles, Theme, ThemeProvider } from '@material-ui/core'
import appTheme from '@styles/theme/appTheme'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiSnackbarContent-root': {
      background: 'rgba(0, 0, 0, 0.88)',
      borderRadius: 4,
      justifyContent: 'center',
    },
    '& .MuiSnackbarContent-message': {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '24px',
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.common.white,
      flex: 'none',
      order: '0',
      alignSelf: 'center',
    },
  },
  variantError: {
    background: '#CC4321 !important',
    borderRadius: '4px',
  },
}))

interface MuiProviderProps {
  children?: React.ReactNode
};

const MuiProvider = ({ children }: MuiProviderProps): JSX.Element => {
  const classes = useStyles();
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <SnackbarProvider
        iconVariant={{
          error: <SvgInfoIcon color="#FFF" />,
        }}
        maxSnack={1}
        autoHideDuration={3000}
        classes={classes}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        {children}
      </SnackbarProvider>
    </ThemeProvider>
  )
}

export default MuiProvider